<template>
  <div>
    <organism-idc-contact-management
      v-if="filterData"
      :filter-list="filterData"
      :role-option="roleOptions"
      :contact-point-name-option="contactPointNameOption"
      :fields="fields"
      :items="contactPointAndSaleList"
      @clickRow="clickRow"
      @onUpdateFilterData="onUpdateFilterData"
      @onUpdateCurrentPageOrPerPage="onUpdateCurrentPageOrPerPage"
      @onSetDefaultFilterData="onSetDefaultFilterData"
    ></organism-idc-contact-management>
  </div>
</template>

<script>
import OrganismIdcContactManagement from "@/components/organisms/portal/internal/OrganismIdcContactManagement.vue"
import mixins from "@/mixins"
import {
  getContactPointAndSaleList,
  getContactPointAndSaleNameList,
} from "@/api/api-module1"
import { mapActions, mapGetters } from "vuex"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

export default {
  name: "IdcManagement",
  components: { OrganismIdcContactManagement },
  mixins: [mixins, mixinsObjectHelper],
  data() {
    return {
      roleOptions: [
        { id: 1, name: "Customer" },
        { id: 2, name: "Sale" },
      ],
      fields: [
        {
          key: "id",
          label: "ID/Passport",
          thClass: "w-25px",
          tdClass: "w-25px",
        },
        {
          key: "role",
          label: "ROLE",
          thClass: "w-25px",
          tdClass: "w-25px",
        },
        {
          key: "fullName",
          label: "FULL NAME",
          thClass: "w-200px",
          tdClass: "w-200px",
        },
        {
          key: "email",
          label: "EMAIL",
          thClass: "w-25px",
          tdClass: "w-25px",
        },
        {
          key: "phone",
          label: "PHONE NUMBER",
          thClass: "w-25px",
          tdClass: "w-25px",
        },
      ],
      contactPointNameOption: [],
      contactPointAndSaleList: [],
      filterData: null,
    }
  },
  computed: {
    ...mapGetters("appFilter", ["getInternalIdcContactPointFilter"]),
  },
  async mounted() {
    await this.getContactPointAndSaleNameListFromApi()
    await this.getContactPointAndSaleListFromApi()
  },
  methods: {
    ...mapActions("appFilter", ["setInternalIdcContactPointFilter"]),

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getInternalIdcContactPointFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    async getContactPointAndSaleNameListFromApi() {
      this.showLoading(true)
      await getContactPointAndSaleNameList()
        .then((response) => {
          if (response) {
            this.contactPointNameOption = response.data
          }
        })
        .finally(() => this.showLoading(false))
    },

    async getContactPointAndSaleListFromApi() {
      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      const filterData = this.filterDecoration()
      await getContactPointAndSaleList(filterData)
        .then((response) => {
          this.filterData.totalCount = response.data.pagination.total
          const updatedFilter = {
            ...this.getInternalIdcContactPointFilter,
            totalCount: response.data.pagination.total,
          }
          this.setInternalIdcContactPointFilter(updatedFilter)
          this.contactPointAndSaleList = response.data.data.map(
            (contactPointOrSale) => {
              return {
                contactPointOrSaleId: contactPointOrSale.contactPointId,
                id: contactPointOrSale.identification,
                role: this.toPascalCase(contactPointOrSale.contactType),
                fullName:
                  contactPointOrSale.firstname +
                  " " +
                  contactPointOrSale.lastname,
                email: {
                  one: contactPointOrSale.emails[0].email,
                  two: contactPointOrSale.emails[1]?.email,
                  three: contactPointOrSale.emails[2]?.email,
                },
                phone: {
                  one: contactPointOrSale.phones[0].phone,
                  two: contactPointOrSale.phones[1]?.phone,
                  three: contactPointOrSale.phones[2]?.phone,
                },
              }
            }
          )
        })
        .finally(() => this.showLoading(false))
    },

    filterDecoration() {
      const filter = {
        PageSize: this.filterData.perPage,
        PageNumber: this.filterData.currentPage,
        ContactPointIdentification: this.filterData.idOrPassportNumber,
        ContactPointType: this.filterData.role.length
          ? this.filterData.role.map((item) => item.name.toUpperCase())
          : undefined,
        ContactPointId:
          this.filterData.contactPoint?.contactPointId || undefined,
        ContactPointEmail: this.filterData.email || undefined,
        ContactPointPhone: this.filterData.phone || undefined,
        IdcId: this.filterData.idcId.replace(/\D/g, "") || undefined,
      }
      return filter
    },

    // click filter
    onUpdateFilterData(filter) {
      filter.currentPage = 1
      this.setInternalIdcContactPointFilter(filter)
      this.getContactPointAndSaleListFromApi()
    },

    onUpdateCurrentPageOrPerPage(filter) {
      const updatedFilter = {
        ...this.getInternalIdcContactPointFilter,
        currentPage: filter.currentPage,
        perPage: filter.perPage,
      }
      this.setInternalIdcContactPointFilter(updatedFilter)
      this.getContactPointAndSaleListFromApi()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        idOrPassportNumber: "",
        role: [],
        contactPoint: "",
        email: "",
        phone: "",
        idcId: "",
        currentPage: 1,
        totalCount: 0,
        perPage: 10,
      }
      this.setInternalIdcContactPointFilter(defaultFilter)
      this.getContactPointAndSaleListFromApi()
    },

    clickRow(record, index) {
      this.$router.push(
        "/internal/web-portal/idc/contact-point-and-sale/" +
          record.contactPointOrSaleId
      )
    },

    toPascalCase(words) {
      return words.replace(/\w+/g, function (w) {
        return w[0].toUpperCase() + w.slice(1).toLowerCase()
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
